import ActionTypes from '../../constants/ActionTypes'

const initialState = {
  data: {},
  isFetching: true
}

export default function (state = initialState, action) {
  switch (action.type) {
    case ActionTypes.HEADER_FOOTER.FETCH_PAGE_SHELL_REQUEST:
      return {
        ...state,
        isFetching: true,
      }
    case ActionTypes.HEADER_FOOTER.FETCH_PAGE_SHELL_SUCCESS :
      return {
        ...state,
        isFetching: false,
        data: action.payload.pageShell,
      }
    default:
      return state
  }
}